import React, { InputHTMLAttributes, forwardRef } from 'react';
import { SwitchBtn } from './style';
interface Props extends InputHTMLAttributes<HTMLInputElement> {
	disabled: boolean,
	checked: boolean,
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
}

const SwitchToggle = forwardRef<HTMLInputElement, Props>((props, ref) => {
	const { disabled, checked, onChange, className } = props;
	return (
		<SwitchBtn className={className}>
			<label className="switch">
				<input 
					checked={checked}
					ref={ref}
					type="checkbox"
					className="checkbox"
					disabled={disabled}
					onChange={onChange} />
				<span className="slider"></span>
			</label>
		</SwitchBtn>
	);
});

SwitchToggle.displayName = 'SwitchToggle';
export default SwitchToggle;
